import { render, staticRenderFns } from "./adsDetail.vue?vue&type=template&id=d19a205c&scoped=true&"
import script from "./adsDetail.vue?vue&type=script&lang=js&"
export * from "./adsDetail.vue?vue&type=script&lang=js&"
import style0 from "./adsDetail.vue?vue&type=style&index=0&id=d19a205c&scoped=true&lang=css&"
import style1 from "./adsDetail.vue?vue&type=style&index=1&lang=css&"
import style2 from "./adsDetail.vue?vue&type=style&index=2&id=d19a205c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19a205c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VImg,VRow,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider,VTextField,VTooltip})
